import React from 'react'
import io, { Socket } from 'socket.io-client'
import Peer from 'peerjs'

import { RouteComponentProps } from 'react-router-dom'

import './Room.scss'

const peers: Record<string, Peer.MediaConnection> = {}

function addVideoStream(video: HTMLVideoElement, stream: MediaStream) {
    video.srcObject = stream
    video.addEventListener('loadedmetadata', () => {
        video.play()
    })
    document.getElementById('videoGrid')!.append(video)
}

function connectToNewUser(userId: string, stream: MediaStream, peer: Peer) {
    console.log(`Calling: "${userId}"`)
    // When we call a user, we're going to send them our video stream.
    const call = peer.call(userId, stream)
    // When they send us back a stream, we'll take it in, then display it on our page.
    const video = document.createElement('video')
    call.on('stream', (userVideoStream) => {
        console.log(`Receiving stream from: "${userId}"`)
        addVideoStream(video, userVideoStream)
    })
    call.on('close', () => {
        video.remove()
    })

    peers[userId] = call
    console.log(peers)
}

type MatchParams = {
    room: string
}
type Props = RouteComponentProps<MatchParams> & {}

type State = {
    socket: typeof Socket | null
    peer: Peer | null
    peerId: string | null
}

export class Room extends React.Component<Props, State> {
    state: State = {
        socket: null,
        peer: null,
        peerId: null,
    }

    componentDidMount() {
        const socket = io('/')
        // Pass in undefined so the server will take care of generating ID
        const peerHost = process.env.REACT_APP_PEER_HOST || '/'
        const peerPath = process.env.REACT_APP_PEER_PATH
        let peerPort = process.env.REACT_APP_PEER_PORT || undefined
        if (peerPort === 'default') {
            peerPort = undefined
        }
        const finalPeerPort: number | undefined = peerPort !== undefined ? Number(peerPort) : undefined

        /* eslint-disable indent */
        const peerOptions: Peer.PeerJSOption = { host: peerHost }
        if (finalPeerPort !== undefined) {
            peerOptions.port = finalPeerPort
        }
        if (peerPath !== '' && peerPath !== undefined) {
            peerOptions.path = peerPath
        }
        const peer = new Peer(undefined, peerOptions)

        navigator.mediaDevices
            .getUserMedia({
                video: true,
                audio: true,
            })
            .then((stream: MediaStream) => {
                const newVideo = document.createElement('video')
                newVideo.muted = true
                addVideoStream(newVideo, stream)
                console.log('Video stream added.')

                // When someone tries to call us, answer the call and send them our
                // current video stream.
                peer.on('call', (call) => {
                    console.log('Answering call.')
                    call.answer(stream)
                    const peerId = call.peer
                    console.log(`Identified call from: "${peerId}"`)
                    peers[peerId] = call
                    console.log(peers)

                    // If two users join, the user which joins latest needs to
                    // respond to the video stream which comes in from the caller/answerer.
                    const video = document.createElement('video')
                    call.on('stream', (userVideoStream: MediaStream) => {
                        console.log('Receiving call stream.')
                        addVideoStream(video, userVideoStream)
                    })
                    call.on('close', () => {
                        video.remove()
                    })
                })

                // NOTE: Suppose user A joins, then user B joins. The tutorial video
                // seems to imply that, in this case, this code should run both on
                // A's client and on B's client. However, it instead only runs on A's client...
                // I probably have a bug somewhere that caused this discrepancy.
                socket.on('user-connected', (userId: string) => {
                    connectToNewUser(userId, stream, peer)
                })
            })

        socket.on('user-disconnected', (userId: string) => {
            console.log(`Disconnected: "${userId}"`)
            // If that user is connected, close it.
            console.log(peers)
            if (peers[userId] !== undefined) {
                console.log(`Closing stream from: "${userId}"`)
                peers[userId].close()
            }
        })

        peer.on('open', (peerId) => {
            // this.setState({ peerId })
            console.log(`Peer is open. Emitting joining room. Self ID: "${peerId}"`)
            const roomId = this.props.match.params.room
            socket.emit('join-room', roomId, peerId)
        })
    }

    // shouldComponentUpdate(nextProps: Props, nextState: State) {
    //     return this.state.socket !== nextState.socket || this.state.peer !== nextState.peer
    // }

    // componentDidUpdate() {
    //     const { socket, peerId } = this.state
    //     if (socket !== null) {
    //         // Emit a join-room event. Wait for the server.

    //         // React when some other user joins the same room.
    //     }
    // }

    render() {
        console.log(this.state.socket)

        return (
            <div>
                <h2>Room</h2>
                <p>Room ID: {this.props.match.params.room}</p>
                {this.state.peerId !== null && <p>My ID: {this.state.peerId}</p>}

                <div id="videoGrid">
                    {/* Our video. Mute our video for ourselves. */}
                    {/* <video muted id="myVideo"></video> */}
                </div>
            </div>
        )
    }
}
